// import Services from '@/services/index';
// import VT from '@/store/types';

export default {
  // [VT.TIME_LOG_DELETE]: ({}, id) => {
  //   return new Promise((resolve, reject) => {
  //     Services.timeLogs.delete(id).then((data) => {
  //       resolve(data);
  //     }).catch((data) => {
  //       reject(data);
  //     });
  //   });
  // },
};
